import { Component, ElementRef, Input, OnInit } from '@angular/core'
import { removeNgTag } from '../shared/utils/host'

@Component({
  selector: 'icos-container',
  template: `
    <section [class]="'icos-container ' + class" [class.is-vertical]="isVertical">
      <ng-content></ng-content>
    </section>
  `,
})
export class IcosContainer implements OnInit {

  @Input() direction: string = ''
  @Input() class: string
  isVertical: boolean = false

  constructor(
    private el: ElementRef,
  ) {
  }

  setVertical(isVertical?: boolean): void {
    if (isVertical && this.direction !== 'horizontal') {
      this.isVertical = true
    }
  }

  ngOnInit(): void {
    console.log('icos Angular: Container Component is discarded, use [Container directive] replace it.')
    this.isVertical = this.direction === 'vertical'
    removeNgTag(this.el.nativeElement)
  }

}
